import testimonial1 from '../assets/Testimonial1.jpg';
import testimonial2 from '../assets/Testimonial2.jpg';
import testimonial3 from '../assets/Testimonial3.jpg';

export const testimonials = [
  {
    image: testimonial1,
    review:
      'I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my peace!',
    name: 'DEBORA SMITH',
    status: 'ENTREPRENEUR',
  },
  {
    image: testimonial2,
    review:
      'I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my peace!',
    name: 'ALICE LOPES',
    status: 'SCHOOL TEACHER',
  },
  {
    image: testimonial3,
    review:
      'I made the right choice by choosing the Fitclub and by choosing the right plan and program I already achieved my peace!',
    name: 'JASON COSTA',
    status: 'UBER',
  },
];
